import styled from 'styled-components';

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  align-items: center;
`;

export const FilterButtonWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const ActiveIndicator = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: ${(props) => props.theme?.colors?.primary || '#FA4616'};
  border-radius: 50%;
  pointer-events: none;
  box-shadow: 0 0 0 2px
    ${(props) =>
      props.theme.name === 'dark' ? 'rgba(30, 30, 30, 1)' : 'white'};
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : 'white'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? props.theme?.colors?.['border-button'] || 'rgba(255,255,255,0.15)'
        : 'rgba(0,0,0,0.08)'};
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94a3b8'
      : props.theme?.colors?.textGray?.secondary || '#94A3B8'};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
  position: relative;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(250, 70, 22, 0.15)'
        : 'rgba(250,70,22,0.05)'};
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};

    svg {
      color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
